import React, {useState, useEffect} from 'react';
import styled from 'styled-components';

import CommunityPostDetail from 'components/containers/campaign/community/CommunityPostDetail';
import CommentList from 'components/containers/comment/list/CommentList';
//Modal
import BottomModal from 'components/presenters/modal/BottomModal';
import CenterModal from 'components/presenters/modal/CenterModal';

export default function CommunityCommentLayout({ match, postNo }) {
    const [loadData, setLoadData]  = useState(false);
    // //BottomModal
    const [bottomModalVisible, setBottomModalVisible] = useState(false);
    const [bottomModalDataList, setBottomModalDataList] = useState([]);
    const [initBottomModal, setInitBottomModal] = useState(false);
    //CenterModal
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState(null);
    const [onCenterModalComplete, setOnCenterModalComplete] = useState(null);
    const [onCenterModalCancel, setOnCenterModalCancel] = useState(null);
    const [initCenterModal, setInitCenterModal] = useState(false);

    const handleBottomModal = (visible, dataList) => {
        setBottomModalVisible(visible);
        setBottomModalDataList(dataList);
    }

    const handleCenterModal = (visible, dataList, onComplete, onCancel) => {
        setCenterModalVisible(visible);
        setCenterModalDataList(dataList);
        setOnCenterModalComplete(onComplete);
        setOnCenterModalCancel(onCancel);
    }

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight;
        
        if(bottom)
        {
            setLoadData(true);
        }
    }

    useEffect(() => {
        if(initBottomModal)
        {
            setBottomModalVisible(false);
            setBottomModalDataList([]);
            setInitBottomModal(false);
        }
    }, [initBottomModal])

    useEffect(() => {
        if(initCenterModal)
        {
            setCenterModalVisible(false);
            setCenterModalDataList(null);
            setOnCenterModalComplete(null);
            setOnCenterModalCancel(null);
            setInitCenterModal(false);
        }
    }, [initCenterModal])

    return (
        <>
            <CommunityCommentWrapper onScroll={handleScroll}>
                <CommunityPostBlock>
                    <CommunityPostDetail 
                        postNo={postNo}
                        onBottomModal={handleBottomModal}
                        onCenterModal={handleCenterModal}
                    />
                </CommunityPostBlock>
                <CommentListBlock>
                    <CommentList
                        loadData={loadData}
                        setLoadData={setLoadData}
                        type={'campaign_community'}
                        match={match}
                        targetNo={postNo}
                        onBottomModal={handleBottomModal}
                        onCenterModal={handleCenterModal}
                        setInitCenterModal={setInitCenterModal}
                        isShowMore={true}
                        isScrollable={false}
                    />
                </CommentListBlock>
            </CommunityCommentWrapper>            
            <BottomModal visible={bottomModalVisible} setVisible={setBottomModalVisible} dataList={bottomModalDataList}/>
            <CenterModal modalVisible={centerModalVisible} dataList={centerModalDataList} onComplete={onCenterModalComplete} onCancel={onCenterModalCancel} zIndex={'500'} showKakaoChatBtn={false}/>
        </>
    )
}

const CommunityCommentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: scroll;
`;

const CommunityPostBlock = styled.div`
    width: 100%;
`;

const CommentListBlock = styled.div`
    width: 100%;
    height: 100%;
`;